import request from '../../api/request'

/** 科目余额、明细账、日记账、资产负债表、利润表共用的会计年度和期号。 */
export default {
  data() {
    return {
      years: [],
      query: { year: '', periodNo: 1 }
    }
  },
  methods: {
    loadLedgerYears(thenLoad) {
      request.get('/finance/ledger/years').then(res => {
        this.years = (res.data || []).map(row => String(row.year))
        if (!this.query.year && this.years.length) this.query.year = this.years[0]
        if (thenLoad) this.load()
      }).catch(() => { if (thenLoad) this.load() })
    },
    onYearChange() {
      this.query.periodNo = 1
      this.load()
    },
    periodParams(extra) {
      return Object.assign({ year: this.query.year, periodNo: this.query.periodNo }, extra || {})
    }
  }
}
